// React & Routing
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Axios for HTTP requests
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// React-Bootstrap Components
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';

// RSuite UI Components
import {
    VStack, HStack, SelectPicker, Toggle, Text, Input, IconButton,
    InputGroup, Button, Table, Panel, Modal, ButtonToolbar,
    Whisper, Tooltip, Loader, Pagination
} from 'rsuite';

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class ActivitiesPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            year: '',
            loading: false,
            searchType: '',
            searchDate: '',
            searchText: '',
            isOpen: false,
            activityData: [],
            activitySortColumn: '',
            activitySortType: '',
            activityLimit: 10,
            activityPage: 1,
            act_type: '',
            act_name: '',
            act_place: '',
            act_start: '',
            act_end: '',
            act_details: '',
        };
    }

    async componentDidMount() {
        const logged = JSON.parse(localStorage.getItem('logged') || '{}');
        const token = logged?.user?.token;

        if (!token) {
            return (window.location.href = '/login');
        }

        const authHeader = {
            headers: { Authorization: `Bearer ${token}` }
        };

        await this.promisedSetState({ authHeader });

        try {
            await this.onRenderContent({ mode: 'read' });
        } catch (error) {
            if (error.response?.status === 401) {
                window.location.href = '/login';
            } else {
                // จัดการ error อื่น ๆ ตามปกติ
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        }
    }

    // Promise-based setState
    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    handleToggle = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }), () => {
            // เรียกใช้งาน callback หลัง toggle
            this.onRenderContent({ mode: 'read' });
        });
    };

    getActivityPaginatedData = () => {
        if (!this.state.activityData) return [];

        const { activitySortColumn, activitySortType, activityLimit, activityPage } = this.state;

        let data = [...this.state.activityData];

        if (activitySortColumn && activitySortType) {
            data.sort((a, b) => {
                let x = a[activitySortColumn];
                let y = b[activitySortColumn];

                if (typeof x === 'string' && typeof y === 'string') {
                    return activitySortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
                }

                return activitySortType === 'asc' ? x - y : y - x;
            });
        }

        const start = activityLimit * (activityPage - 1);
        const end = start + activityLimit;

        return data.slice(start, end);
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true })

                // ดึง ID ผู้ใช้จาก localStorage
                const id = JSON.parse(localStorage.getItem('logged') || '{}')?.user?.user?.id;

                if (!id) {
                    throw new Error("ไม่พบข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบใหม่");
                }

                const activityRes = await axios.post(
                    `${process.env.REACT_APP_API}/activity/applicant`,
                    {
                        applicants_id: id,
                        search_type: this.state.searchType,
                        search_date: this.state.searchDate,
                        search_text: this.state.searchText,
                    },
                    this.state.authHeader
                );

                const activityApiData = activityRes.data;

                // ชื่อเดือนภาษาไทย
                const monthNamesThai = [
                    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                ];

                // ฟังก์ชันแปลงวันที่เป็นรูปแบบไทยแบบย่อ (วันที่ เดือน ปี พ.ศ. สองหลัก)
                function formatDateThaiLong(dateString) {
                    if (!dateString) return '';
                    const date = new Date(dateString);
                    if (isNaN(date)) return '';

                    const day = date.getDate();
                    const monthNamesThai = [
                        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                    ];
                    const month = monthNamesThai[date.getMonth()];
                    const fullYear = date.getFullYear() + 543;
                    const year = fullYear % 100; // 2 ตัวท้ายปี

                    return { day, month, year };
                }

                function formatActDate(startDateStr, endDateStr) {
                    const start = formatDateThaiLong(startDateStr);
                    const end = formatDateThaiLong(endDateStr);

                    if (!start || !end) return '';

                    if (start.day === end.day && start.month === end.month && start.year === end.year) {
                        return `${start.day} ${start.month} ${start.year}`;
                    }

                    if (start.year === end.year && start.month === end.month) {
                        return `${start.day} - ${end.day} ${start.month} ${start.year}`;
                    }

                    if (start.year === end.year && start.month !== end.month) {
                        return `${start.day} ${start.month} - ${end.day} ${end.month} ${start.year}`;
                    }

                    return `${start.day} ${start.month} ${start.year} - ${end.day} ${end.month} ${end.year}`;
                }

                // แปลงข้อมูล API ให้เป็นข้อมูลที่แสดงผลได้ง่าย
                const mappedActivityData = (Array.isArray(activityApiData) ? activityApiData : [activityApiData]).map(item => ({
                    id: item.id,
                    actType: item.act_type || "",
                    actName: item.act_name || "",
                    actPlace: item.act_place || "",
                    actDate: formatActDate(item.act_start, item.act_end) || ""
                }));

                await this.promisedSetState({
                    activityData: mappedActivityData,
                });

                const paginatedData = this.getActivityPaginatedData();

                // Setting state using promisedSetState
                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>การเข้าร่วมกิจกรรม</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        {this.state.isOpen && (
                            <Row>
                                <Col lg={3} className='mb-3'>
                                    <VStack>
                                        <label>ประเภทกิจกรรม</label>
                                        <SelectPicker
                                            size='lg'
                                            data={[
                                                { value: 'กิจกรรมตามสัญญาทุน', label: 'กิจกรรมตามสัญญาทุน' },
                                                { value: 'กิจกรรมเก็บชั่วโมงอาสา', label: 'กิจกรรมเก็บชั่วโมงอาสา' }
                                            ]}
                                            searchable={false}
                                            style={{ width: 220 }}
                                            placeholder="กรุณาเลือก"
                                            onChange={async e => {
                                                await this.promisedSetState({ searchType: e });
                                                this.onRenderContent({ mode })
                                            }}
                                        />
                                    </VStack>
                                </Col>
                                <Col lg={3} className='mb-3'>
                                    <VStack>
                                        <label>วันที่จัดกิจกรรม</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.searchDate}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async e => {
                                                    await this.promisedSetState({ searchDate: e });
                                                    this.onRenderContent({ mode })
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ searchDate: null });
                                                    this.onRenderContent({ mode })
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{
                                                    borderRadius: '0 6px 6px 0',
                                                }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                            </Row>
                        )}

                        <Row>
                            <Col className='mb-3'>
                                <HStack>
                                    <InputGroup size='lg' style={{ width: 300 }}>
                                        <InputGroup.Addon>
                                            <i className="bi bi-search"></i>
                                        </InputGroup.Addon>
                                        <Input
                                            onChange={e => this.setState({ searchText: e })}
                                            onKeyDown={e => e.key === 'Enter' && this.onRenderContent({ mode: 'read' })}
                                        />
                                    </InputGroup>
                                    <Button appearance="primary">ค้นหา</Button>
                                </HStack>
                            </Col>
                            <Col lg={4} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Toggle
                                    size="md"
                                    checked={this.state.isOpen}
                                    onChange={this.handleToggle}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                    }}
                                >
                                    <Text muted>ตัวกรอง</Text>
                                </Toggle>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12} className='mb-3'>
                                <Panel
                                    header="ประวัติการเข้าร่วมกิจกรรม"
                                    className="shadow-sm"
                                    style={{ backgroundColor: '#FFF', padding: '0.5em', height: '100%' }}
                                >
                                    <Button
                                        className='mt-3 mb-2'
                                        size='sm'
                                        startIcon={<i className="bi bi-plus-lg"></i>}
                                        color="green"
                                        appearance="primary"
                                        onClick={() => this.onModal({ mode: 'insert', id })} >
                                        เพิ่มกิจกรรม
                                    </Button>

                                    <Row className='mb-2'>
                                        <Col>
                                            <Table
                                                autoHeight
                                                data={paginatedData}
                                                bordered
                                                cellBordered
                                                className='shadow-sm'
                                                sortColumn={this.state.sortColumn}
                                                sortType={this.state.sortType}
                                                onSortColumn={async (sortColumn, sortType) => {
                                                    await this.handleSortColumn(sortColumn, sortType);
                                                }}
                                            >
                                                <Column width={240} resizable>
                                                    <HeaderCell align='center'>วันที่กิจกรรม</HeaderCell>
                                                    <Cell align='center' dataKey="actDate" />
                                                </Column>

                                                <Column width={170} resizable>
                                                    <HeaderCell>ประเภท</HeaderCell>
                                                    <Cell dataKey="actType" />
                                                </Column>

                                                <Column width={340} resizable>
                                                    <HeaderCell>ชื่อกิจกรรม</HeaderCell>
                                                    <Cell dataKey="actName" />
                                                </Column>

                                                <Column width={400} resizable>
                                                    <HeaderCell>สถานที่</HeaderCell>
                                                    <Cell dataKey="actPlace" />
                                                </Column>


                                                <Column width={115} align="center" fixed="right">
                                                    <HeaderCell>...</HeaderCell>
                                                    <Cell style={{ padding: '6px' }}>
                                                        {rowData => (
                                                            <ButtonToolbar>
                                                                <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                    <IconButton size='sm'
                                                                        color="yellow"
                                                                        appearance="primary"
                                                                        icon={<i className="bi bi-pencil-square"></i>}
                                                                        onClick={async () => {
                                                                            await this.promisedSetState({ changePassword: false, password: '', confirm_password: '' })
                                                                            await this.onModal({ mode: 'update', id: rowData.id })
                                                                        }}
                                                                    />
                                                                </Whisper>
                                                                <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                    <IconButton size='sm'
                                                                        color="red"
                                                                        appearance="primary"
                                                                        icon={<i className="bi bi-trash-fill"></i>}
                                                                        onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                                    />
                                                                </Whisper>
                                                            </ButtonToolbar>
                                                        )}
                                                    </Cell>
                                                </Column>
                                            </Table>

                                            <div style={{ padding: 20 }}>
                                                <Pagination
                                                    prev
                                                    next
                                                    first
                                                    last
                                                    ellipsis
                                                    boundaryLinks
                                                    maxButtons={5}
                                                    size="xs"
                                                    layout={['total', '|', 'pager']}
                                                    total={this.state.activityData ? this.state.activityData.length : 0}
                                                    limit={this.state.activityLimit}
                                                    activePage={this.state.activityPage}
                                                    onChangePage={async (e) => {
                                                        await this.promisedSetState({ activityPage: e }); // Update current page
                                                        await this.onRenderContent({ mode: 'read' }); // Fetch new data based on page
                                                    }}
                                                />
                                            </div>

                                        </Col>
                                    </Row>
                                </Panel>
                            </Col>
                        </Row>
                    </>
                })

                await this.promisedSetState({ loading: false })

            } catch (error) {
                // Handle errors here
                console.error('Error fetching data or rendering content:', error);

                // Redirect to Log In
                window.location.href = '/login';
            }
        }
    };

    onModal = async ({ mode, id, sel }) => {
        let data;

        if (!sel) {
            // ค่าเริ่มต้น
            data = {
                act_type: '',
                act_name: '',
                act_place: '',
                act_start: '',
                act_end: '',
                act_details: ''
            };

            if (mode === 'update') {
                const response = await axios.get(`${process.env.REACT_APP_API}/activity/${id}`, this.state.authHeader);
                const item = response.data;

                data = {
                    act_type: item.act_type || '',
                    act_name: item.act_name || '',
                    act_place: item.act_place || '',
                    act_start: item.act_start || '',
                    act_end: item.act_end || '',
                    act_details: item.act_details || ''
                };
            }

            await this.promisedSetState(data);
        }

        if (mode === 'insert' || mode === 'update') {
            await this.promisedSetState({
                modal: <Modal size={'md'}
                    backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>ข้อมูลการเข้าร่วมกิจกรรม</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>

                            <Row className='mb-3'>
                                <Col lg={6}>
                                    <HStack>
                                        <label>ประเภทกิจกรรม <span style={{ color: 'red' }}>*</span></label>
                                        <SelectPicker
                                            className='kD8zQ'
                                            size='lg'
                                            data={[
                                                { value: 'กิจกรรมตามสัญญาทุน', label: 'กิจกรรมตามสัญญาทุน' },
                                                { value: 'กิจกรรมเก็บชั่วโมงอาสา', label: 'กิจกรรมเก็บชั่วโมงอาสา' }
                                            ]}
                                            defaultValue={this.state.act_type}
                                            searchable={false}
                                            style={{ width: 220 }}
                                            placeholder="กรุณาเลือก"
                                            onChange={e => this.setState({ act_type: e })}
                                            onClean={() => this.setState({ act_type: '' })}
                                        />
                                    </HStack>
                                </Col>
                            </Row>

                            <Row className='mb-3'>
                                <Col lg={9}>
                                    <VStack>
                                        <label>ชื่อกิจกรรม <span style={{ color: 'red' }}>*</span></label>
                                        <Input
                                            className='aR3mB'
                                            size='sm'
                                            defaultValue={this.state.act_name}
                                            onChange={e => this.setState({ act_name: e })} />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>สถานที่ <span style={{ color: 'red' }}>*</span></label>
                                        <Input
                                            className='qT9vX'
                                            size='sm'
                                            defaultValue={this.state.act_place}
                                            onChange={e => this.setState({ act_place: e })} />
                                    </VStack>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={4} className='mb-3'>
                                    <VStack>
                                        <label>วันที่จัดกิจกรรม <span style={{ color: 'red' }}>*</span></label>
                                        <div className='tBvv4' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                className='Lm4sC'
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.act_start}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async (e) => {
                                                    await this.promisedSetState({ act_start: e });
                                                    await this.onModal({ mode, id, sel: true });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ act_start: '' });
                                                    await this.onModal({ mode, id, sel: true });
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{
                                                    borderRadius: '0 6px 6px 0',
                                                }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                                <Col lg={4} className='mb-3'>
                                    <VStack>
                                        <label>ถึง <span style={{ color: 'red' }}>*</span></label>
                                        <div className='CIzvL' style={{ display: 'flex', alignItems: 'center' }}>
                                            <ThaiDatePicker
                                                className='wF7nD'
                                                placeholder="วัน/เดือน/ปี พ.ศ."
                                                value={this.state.act_end}
                                                inputProps={{
                                                    style: {
                                                        padding: '6px 8px',
                                                        borderRadius: '6px 0 0 6px',
                                                        border: '1px solid #E7E5E4',
                                                        width: '200px',
                                                    }
                                                }}
                                                onChange={async (e) => {
                                                    await this.promisedSetState({ act_end: e });
                                                    await this.onModal({ mode, id, sel: true });
                                                }}
                                                onClean={async () => {
                                                    await this.promisedSetState({ act_end: '' });
                                                    await this.onModal({ mode, id, sel: true });
                                                }}
                                            />
                                            <IconButton
                                                icon={<i className="bi bi-calendar3"></i>}
                                                size="md"
                                                style={{
                                                    borderRadius: '0 6px 6px 0',
                                                }}
                                            />
                                        </div>
                                    </VStack>
                                </Col>
                            </Row>

                            <Row className='mb-3'>
                                <Col>
                                    <label>รายละเอียด <span style={{ color: 'red' }}>*</span></label>
                                    <Input
                                        className='zK2yL'
                                        as="textarea"
                                        rows={3}
                                        defaultValue={this.state.act_details}
                                        onChange={e => this.setState({ act_details: e })}
                                    />
                                </Col>
                            </Row>

                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy-fill"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode, id })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            });
        }
    };

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ mode, id }) => {
        // --------------------- DELETE MODE ---------------------
        if (mode === 'delete') {
            this.setState({ loading: true });

            Swal.fire({
                title: `คุณต้องการลบข้อมูลใช่หรือไม่?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `<div style="font-size: 1.2rem">ตกลง</div>`,
                cancelButtonText: `<div style="font-size: 1.2rem">ยกเลิก</div>`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const response = await axios.delete(
                            `${process.env.REACT_APP_API}/activity/${id}`,
                            this.state.authHeader
                        );

                        const data = response.data;

                        if (data.message === 'successfully') {
                            Swal.fire({
                                title: "ลบข้อมูลเรียบร้อยแล้ว",
                                icon: "success",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            }).then(async () => {
                                await this.onRenderContent({ mode: 'read' });
                                this.setState({ modal: null });
                            });
                        } else {
                            Swal.fire({
                                title: "เกิดข้อผิดพลาดในการลบ",
                                text: data.message || 'ไม่สามารถลบข้อมูลได้',
                                icon: "error",
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                        }
                    } catch (error) {
                        if (error.response?.status === 401) {
                            window.location.href = '/login';
                        } else {
                            // จัดการ error อื่น ๆ ตามปกติ
                            Swal.fire({
                                title: 'เกิดข้อผิดพลาด',
                                text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                                icon: 'error',
                                confirmButtonText: 'ตกลง'
                            });
                        }
                    }
                }
            });

            this.setState({ loading: false });
            return;
        }

        const validateActivity = async () => {
            const validationPromises = [
                this.Validate(this.state.act_type, 'kD8zQ', ''),
                this.Validate(this.state.act_name, 'aR3mB', ''),
                this.Validate(this.state.act_place, 'qT9vX', ''),
                this.Validate(this.state.act_start, 'tBvv4', ''),
                this.Validate(this.state.act_end, 'CIzvL', ''),
                this.Validate(this.state.act_details, 'zK2yL', ''),
            ];

            const results = await Promise.all(validationPromises);
            if (!results.every(r => r === true)) return false;

            // ✅ ตรวจสอบวันที่
            const start = new Date(this.state.act_start);
            const end = new Date(this.state.act_end);
            if (start > end) {
                Swal.fire({
                    title: "วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
                return false;
            }

            return true;
        };

        const isValid = await validateActivity();
        if (!isValid) return;

        this.setState({ loading: true });

        try {
            if (mode === 'insert') {
                const response = await axios.post(
                    `${process.env.REACT_APP_API}/activity`,
                    {
                        applicants_id: id,
                        act_type: this.state.act_type || '',
                        act_name: this.state.act_name || '',
                        act_place: this.state.act_place || '',
                        act_start: this.state.act_start || '',
                        act_end: this.state.act_end || '',
                        act_details: this.state.act_details || ''
                    },
                    this.state.authHeader
                );

                const data = response.data;

                if (data.message === 'successfully') {
                    Swal.fire({
                        title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    }).then(async () => {
                        await this.promisedSetState({
                            act_type: '',
                            act_name: '',
                            act_place: '',
                            act_start: '',
                            act_end: '',
                            act_details: ''
                        });
                        await this.onRenderContent({ mode: 'read' });
                        this.setState({ modal: null });
                    });
                }
            } else if (mode === 'update') {
                const response = await axios.patch(
                    `${process.env.REACT_APP_API}/activity`,
                    {
                        id: id, // ต้องมี id เพื่อระบุ record ที่ต้องการอัปเดต
                        act_type: this.state.act_type || '',
                        act_name: this.state.act_name || '',
                        act_place: this.state.act_place || '',
                        act_start: this.state.act_start || '',
                        act_end: this.state.act_end || '',
                        act_details: this.state.act_details || ''
                    },
                    this.state.authHeader
                );

                const data = response.data;

                if (data.message === 'successfully') {
                    Swal.fire({
                        title: "อัปเดตข้อมูลเรียบร้อยแล้ว",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    }).then(async () => {
                        await this.onRenderContent({ mode: 'read' });
                        this.setState({ modal: null });
                    });
                }
            }
        } catch (error) {
            if (error.response?.status === 401) {
                window.location.href = '/login';
            } else {
                // จัดการ error อื่น ๆ ตามปกติ
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
            }
        }

        this.setState({ loading: false });
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
